;(function () {
  angular
    .module('contrast.org.permissions')
    .directive('notEnterprise', function (UserService, permissions) {
      'ngInject'

      return {
        link: function (scope, element, attrs) {
          if (!_.isString(attrs.notEnterprise)) {
            // eslint-disable-next-line no-throw-literal
            throw 'notEnterprise value must be a string'
          }

          var value = attrs.notEnterprise.trim()

          function toggleVisibilityBasedOnPermission() {
            var hasPermission = permissions.hasPermission(value)

            if (UserService.isEnterprise() && hasPermission) {
              element.hide()
            } else {
              element.show()
            }
          }

          toggleVisibilityBasedOnPermission()
          scope.$on('permissions:updated', toggleVisibilityBasedOnPermission)
          scope.$on('organization:loaded', toggleVisibilityBasedOnPermission)
        }
      }
    })
})()
